import { ActionLink } from '@cian/ui-kit';
import { IconFunctionalWarningCircle24 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Alert.css';

import type { TAlertButton } from '../../types/alert';

interface IAlertProps {
  isError: boolean;
  isVisible: boolean;
  message: string;
  withOffset?: boolean;
  onClose(): void;
  onCancel?: () => void;
  button?: TAlertButton;
}

export const Alert: React.FC<IAlertProps> = ({
  isError,
  isVisible,
  message,
  withOffset,
  button,
  onClose,
  onCancel,
}) => {
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timeout: any;
    if (isVisible) {
      timeout = setTimeout(onClose, 4000);
    }

    return () => clearTimeout(timeout);
  }, [isVisible, onClose]);

  return (
    <div className={classNames(styles['alert'], isVisible && styles['visible'], withOffset && styles['with-offset'])}>
      {isError && (
        <div className={styles['icon-wrapper']}>
          <IconFunctionalWarningCircle24 color={'control-negative-primary-pressed'} />
        </div>
      )}

      {message}
      {onCancel && (
        <button className={styles['button']} type="button" onClick={onCancel}>
          Отменить
        </button>
      )}
      {button && (
        <div className={styles['action-link-wrapper']}>
          <ActionLink onClick={button.onClick}>{button.text}</ActionLink>
        </div>
      )}
    </div>
  );
};
